export const c_menu_m_nav_c_menu_m_top_Bottom = {
  "name": "--pf-c-menu--m-nav--c-menu--m-top--Bottom",
  "value": "calc(0 + 0)",
  "var": "var(--pf-c-menu--m-nav--c-menu--m-top--Bottom)"
};
export default c_menu_m_nav_c_menu_m_top_Bottom;